<template>
    <div>
        <oMenu></oMenu>
        <router-view></router-view>
        <newFooter></newFooter>
    </div>
</template>

<script>
export default {
    components: {
        oMenu: () => import('@/components/layout/menubase.vue'),
        newFooter: () => import('@/components/layout/footer.vue'),
    },
};
</script>